import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Section } from "@/components/commesse";
import { ItemRow } from "@/components/admin/pratica";
import { ExtrasSection } from "@/components/admin/extras";
import { PhaseMapEditor } from "@/components/admin/phaseMap";

export const CantiereDocs = ({ oid }) => {
  const [p, setP] = useState(null);
  useEffect(() => { api.get(`/amministrazione/${oid}`).then((r) => setP(r.data)).catch(() => {}); }, [oid]);
  if (!p) return null;
  const groups = [["richieste", "Documenti del cliente", (i) => i.kind.startsWith("richiesta")], ["firme", "Documenti da firmare", (i) => i.kind === "firma"], ["fatture", "Fatture al cliente", (i) => i.kind === "fattura"]];
  return (
    <div className="space-y-6" data-testid="cantiere-docs">
      <p className="text-sm text-[#757575]">Carica il file, invialo al cliente via email e spunta quando è fatto: la data di completamento si può correggere aprendo la voce. Le fatture si preparano da sole nello <Link to="/admin/amministrazione/scadenzario" className="underline">Scadenzario</Link> al raggiungimento della fase (abbinamenti in fondo alla pagina). · {p.client_progress.done} di {p.client_progress.total} completate</p>
      {groups.map(([id, label, f]) => (
        <Section key={id} label={label} testid={`cantiere-docs-${id}`}>
          <div className="space-y-2">{p.client_items.filter(f).map((it) => <ItemRow key={it.key} it={it} oid={oid} scope="cliente" staff={p.staff} onSaved={setP} />)}</div>
        </Section>
      ))}
      <ExtrasSection p={p} oid={oid} setP={setP} />
      <PhaseMapEditor url={`/amministrazione/${oid}/phase-invoices`} perOrder />
    </div>
  );
};
